import React from "react";
import { Redirect, Route } from "react-router-dom/cjs/react-router-dom.min";
import { getToken, getRole } from "../service/AuthService";

const PublicRoute = ({ component: Component, ...rest }) => {
  return (
      <Route
  {...rest}
  render={props => {
    const token = getToken();
    const role  = getRole();

    if (!token) return <Component {...props} />;
    return <Redirect to={{ pathname: role === "follower" ? "/myTrades" : "/trading" }} />;
  }}
  />
  );
};

export default PublicRoute;